import { type VincoloCardinalitaDTO } from '@framework/api-client/api/inquiries/schemas/vincoloCardinalitaDTO.ts';
import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';

/**
 * Ritorna i suoi vincoli di cardinalità passati nel contesto se indicati,
 * altrimenti riitorna quelli della richiesta,
 */
export function getCardinalityConstraintsViolations(
  submission: RichiestaDTO | null | undefined,
  constraints: VincoloCardinalitaDTO[] | undefined | null,
) {
  if (constraints) {
    return constraints;
  }

  if (submission?.violazioneVincoloCardinalita) {
    return submission?.violazioneVincoloCardinalita;
  }

  return null;
}
